import type { ReactElement, ReactNode } from "react";

import styles from "./Badge.module.css";

export type BadgeTone = "neutral" | "success" | "warning" | "danger" | "info" | "outline";

export interface BadgeProps {
  readonly tone: BadgeTone;
  readonly children: ReactNode;
}

/**
 * A short state label.
 *
 * The tone paints it, and the children say what it means. Both always: colour
 * is never the only carrier of meaning, so a badge with no text is not a
 * badge, it is a coloured dot nobody can read.
 */
export function Badge({ tone, children }: BadgeProps): ReactElement {
  return (
    <span className={[styles.badge, styles[tone]].join(" ")} data-tone={tone}>
      {children}
    </span>
  );
}
